import { logUsage } from 'owa-analytics';
import { type StateChangeSource } from '../types/StateChangeSource';

export const logLeftPaneStateChange = (
    showLeftPane: boolean,
    stateChangeSource: StateChangeSource
): void => {
    if (stateChangeSource === undefined) {
        return;
    }

    const loggerMap: Record<StateChangeSource, (show: boolean, src: StateChangeSource) => void> = {
        [0]: (show, src) => logUsage('TnS_FolderPaneChange_Ribbon', [show, src]),
        [1]: (show, src) => logUsage('TnS_FolderPaneChange_LeftNav', [show, src]),
        [3]: (show, src) => logUsage('TnS_FolderPaneChange_MailList', [show, src]),
        [2]: (show, src) => logUsage('TnS_FolderPaneChange_Tabs', [show, src]),
        [4]: (show, src) => logUsage('TnS_FolderPaneChange_Shortcut', [show, src]),
        [5]: (show, src) => logUsage('TnS_FolderPaneChange_RibbonViewTab', [show, src]),
        [6]: (show, src) => logUsage('TnS_FolderPaneChange_LeftNavToggleButton', [show, src]),
        [7]: (show, src) => logUsage('TnS_FolderPaneChange_LeftNavDrag', [show, src]),
    };

    const logFn = loggerMap[stateChangeSource];
    if (logFn) {
        logFn(showLeftPane, stateChangeSource);
    }
};
